module.exports = __webpack_public_path__ + "img/feelings.7a8cd004.png";